package com.eladfinish.bible.contest.data

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

/**
 * Developed by
 * @author Elad Finish
 */

@Serializable
data class ExpressionReferences(
    @SerialName("name") val name: String,
    @SerialName("locations") val locations: List<Reference>?,
    @SerialName("chapters") val chapters: List<Int>?,
)

@Serializable
data class Reference(
    @SerialName("c") val chapter: Int,
    @SerialName("v") val versesList: List<List<Int>>?,
)
